import React from 'react';
import {isNull, isUndefined} from 'lodash'
import { useSelector } from "react-redux";
import {Box} from '@material-ui/core'
import { injectIntl } from 'react-intl';

function WelcomeComponent(props) {
    const Flags = useSelector(state => state.accountsData.Flags)
    const authUser = useSelector(state => state.auth.authUser)
console.log(props,"welcome")
  const returnWelcomeMessage = () => {
    var now = new Date().getHours()
    if(5 <= now && now <= 9) return `${props.intl.formatMessage({ id: 'Massage.Good.Morning' })} ${authUser.user_fnamn} ${authUser.user_lnamn}!`
    if(10 <= now && now <= 11) return `${props.intl.formatMessage({ id: 'Massage.Good.Morning1' })} ${authUser.user_fnamn} ${authUser.user_lnamn}!`
    if(12 <= now && now <= 15) return `${props.intl.formatMessage({ id: 'Massage.Good.day' })} ${authUser.user_fnamn} ${authUser.user_lnamn}!`
    if(16 <= now && now <= 18) return `${props.intl.formatMessage({ id: 'Massage.Good.afternoon' })} ${authUser.user_fnamn} ${authUser.user_lnamn}!`
    if((19 <= now && now <= 23) || (0 <= now && now <= 4)) return `${props.intl.formatMessage({ id: 'Massage.Good.night' })} ${authUser.user_fnamn} ${authUser.user_lnamn}!`
    else return ''
  }

  return (
    <React.Fragment> 
        <Box container  className="align-items-center justify-content-between h-100 p-2 text-center">
        <Box item xs={12} md={4}>
        {
                isNull(Flags.KontoLogo) ? '' : 
                <img  src={Flags.KontoLogo} alt="" style={{ objectFit: 'contain', maxHeight: isUndefined(props.ImageHeight)?50:props.ImageHeight, height: '100%'}} />
            }
        </Box>
        <Box item xs={12} md={8}>
        <h3 className="mb-0 text-center" style={{
            color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`,
            fontSize:props.textSize}}>{returnWelcomeMessage()}</h3>
        </Box>
        </Box>
    </React.Fragment>
  );
}

export default injectIntl(WelcomeComponent);